import { render } from "./CopyrightPage.vue?vue&type=template&id=14ef2ab5&scoped=true"
import script from "./CopyrightPage.vue?vue&type=script&lang=js"
export * from "./CopyrightPage.vue?vue&type=script&lang=js"

import "./CopyrightPage.vue?vue&type=style&index=0&id=14ef2ab5&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ef2ab5"]])

export default __exports__